<template>
  <topico-sala-aula ref="topicoSalaAula" :titulo="titulo" :ementa-curso="ementaCurso" class="topicoSalaAula">
    <topico-curso-expirado v-if="isCursoExpirado"></topico-curso-expirado>
    <topico-video v-if="!isCursoExpirado && isTopicoVideo && !perfil.perfil.player_alternativo" :ementa-curso="ementaCurso"></topico-video>
    <topico-players v-if="!isCursoExpirado && isTopicoVideo && perfil.perfil.player_alternativo" :ementa-curso="ementaCurso"></topico-players>
    <topico-questao-objetiva v-if="!isCursoExpirado && isTopicoQuestaoObjetiva" :ementa-curso="ementaCurso"></topico-questao-objetiva>
    <topico-questao-discursiva v-if="!isCursoExpirado && isTopicoQuestaoDiscursiva" :ementa-curso="ementaCurso"></topico-questao-discursiva>
    <topico-texto v-if="!isCursoExpirado && isTopicoTexto" :ementa-curso="ementaCurso"></topico-texto>
    <topico-pdf v-if="!isCursoExpirado && isTopicoPdf" :ementa-curso="ementaCurso"></topico-pdf>
    <topico-imagem v-if="!isCursoExpirado && isTopicoImagem" :ementa-curso="ementaCurso"></topico-imagem>
    <topico-lab-virtual v-if="!isCursoExpirado && isTopicoLabVirtual" :ementa-curso="ementaCurso"></topico-lab-virtual>
    <topico-experiencia-imersiva v-if="!isCursoExpirado && isTopicoExperienciaImersiva" :ementa-curso="ementaCurso"></topico-experiencia-imersiva>
    <topico-quiz v-if="!isCursoExpirado && isTopicoQuiz" :quiz="quiz" :curso="ementaCurso" ></topico-quiz>
    <topico-formulario-avaliativo v-if="!isCursoExpirado && isTopicoFormularioAvaliativo" :ementa-curso="ementaCurso"></topico-formulario-avaliativo>
    <topico-link v-if="!isCursoExpirado && isTopicoLink" :ementa-curso="ementaCurso"></topico-link>
    <topico-jaleklinico v-if="!isCursoExpirado && isTopicoJaleklinico" :ementa-curso="ementaCurso"></topico-jaleklinico>
  </topico-sala-aula>
</template>

<script>
import TopicoJaleklinico from '@/modules/SalaAula/components/topicos/TopicoJaleklinico'
import TopicoLink from '@/modules/SalaAula/components/topicos/TopicoLink'
import TopicoFormularioAvaliativo from '@/modules/SalaAula/components/topicos/TopicoFormularioAvaliativo'
import TopicoVideo from '@/modules/SalaAula/components/topicos/TopicoVideo'
import TopicoPlayers from '@/modules/SalaAula/components/topicos/TopicoPlayers'
import TopicoQuestaoDiscursiva from '@/modules/SalaAula/components/topicos/TopicoQuestaoDiscursiva'
import TopicoQuestaoObjetiva from '@/modules/SalaAula/components/topicos/TopicoQuestaoObjetiva'
import TopicoTexto from '@/modules/SalaAula/components/topicos/TopicoTexto'
import TopicoPdf from '@/modules/SalaAula/components/topicos/TopicoPdf'
import TopicoImagem from '@/modules/SalaAula/components/topicos/TopicoImagem'
import TopicoLabVirtual from '@/modules/SalaAula/components/topicos/TopicoLabVirtual'
import TopicoExperienciaImersiva from '@/modules/SalaAula/components/topicos/TopicoExperienciaImersiva'
import SalaAulaAPI from '@/api/sala-aula-api'
import TipoTopico, { TipoTopicoUtil } from '@/core/types/tipo-topico-licao'
import TopicoSalaAula from '@/modules/SalaAula/components/TopicoSalaAula'
import PerfilAPI from '@/api/perfil-api'
import TopicoQuiz from '@/modules/SalaAula/components/ferramenta-estudo/items/Quiz'
import TopicoCursoExpirado from '@/modules/SalaAula/components/topicos/TopicoCursoExpirado'
import DateUtils from '@/core/utils/date-utils'

export default {
  name: 'TopicoSalaAulaInterno',
  components: {
    TopicoImagem,
    TopicoPdf,
    TopicoTexto,
    TopicoQuestaoDiscursiva,
    TopicoQuestaoObjetiva,
    TopicoSalaAula,
    TopicoVideo,
    TopicoLabVirtual,
    TopicoExperienciaImersiva,
    TopicoPlayers,
    TopicoQuiz,
    TopicoFormularioAvaliativo,
    TopicoLink,
    TopicoCursoExpirado,
    TopicoJaleklinico
  },
  data () {
    return {
      tipoTopico: null,
      filtroTopico: {
        curso: '',
        modulo: '',
        licao: '',
        topico: ''
      },
      titulo: '',
      ementaCurso: {},
      perfil: '',
      quiz: {},
      ementaCursoLoad: false
    }
  },
  beforeRouteUpdate  (to, from, next) {
    this.filtroTopico = {
      curso: to.params.referenciaCurso,
      modulo: to.params.modulo,
      licao: to.params.licao,
      topico: to.params.topico
    }

    this.obterTopico()

    next()
  },

  async mounted () {
    this.filtroTopico = {
      curso: this.$route.params.referenciaCurso,
      modulo: this.$route.params.modulo,
      licao: this.$route.params.licao,
      topico: this.$route.params.topico
    }
    this.perfil = await PerfilAPI.obterPerfil()
    this.obterTopico()
  },

  computed: {
    isTopicoVideo: function () {
      return TipoTopico.VIDEO === this.tipoTopico
    },
    isTopicoQuestaoObjetiva: function () {
      return TipoTopico.QUESTAO_OBJETIVA === this.tipoTopico
    },
    isTopicoQuestaoDiscursiva: function () {
      return TipoTopico.QUESTAO_DISCURSIVA === this.tipoTopico
    },
    isTopicoTexto: function () {
      return TipoTopico.TEXTO === this.tipoTopico
    },
    isTopicoPdf: function () {
      return TipoTopico.PDF === this.tipoTopico
    },
    isTopicoImagem: function () {
      return TipoTopico.IMAGEM === this.tipoTopico
    },
    isTopicoLabVirtual: function () {
      return TipoTopico.LABVIRTUAL === this.tipoTopico
    },
    isTopicoExperienciaImersiva: function () {
      return TipoTopico.EXPERIENCIA_IMERSIVA === this.tipoTopico
    },
    isTopicoQuiz: function () {
      return TipoTopico.QUIZ === this.tipoTopico
    },
    isTopicoFormularioAvaliativo: function () {
      return TipoTopico.FORMULARIO_AVALIATIVO === this.tipoTopico
    },
    isTopicoLink: function () {
      return TipoTopico.LINK === this.tipoTopico
    },
    isTopicoJaleklinico: function () {
      return TipoTopico.JALEKLINICO === this.tipoTopico
    },
    autoplay: function () {
      return JSON.parse(localStorage.getItem('autoplay'))
    },
    cursoComDataExpiracao: function () {
      return this.$empresaUtils.temAcesso(this.$tipoAcesso.CURSO_DATA_EXPIRACAO.nome, this.$configEmpresa.rotasRestritasAcesso)
    },
    isCursoExpirado: function () {
      if (this.cursoComDataExpiracao && this.ementaCursoLoad && this.ementaCurso.curso_estrutura.dataExpiracao) {
        return this.ementaCurso.curso_estrutura.dataExpiracao < DateUtils.currentDateTime()
      } else {
        return false
      }
    }
  },

  methods: {
    obterTopico: function () {
      const loader = this.$loading.show()
      this.$store.dispatch('resetCadernoLateral')
      SalaAulaAPI.obterTopico(this.filtroTopico.curso, this.filtroTopico.modulo, this.filtroTopico.licao, this.filtroTopico.topico)
        .then(data => {
          this.ementaCurso = data
          this.ementaCursoLoad = true
          this.tipoTopico = TipoTopicoUtil.obterTipoTopicosPorId(data.topico_escolhido.tipo)
          this.titulo = data.topico_escolhido.titulo
          if (data.topico_escolhido.tipo === 10) {
            this.quiz = data.quiz
          }
          const $topicoSalaAulaRef = this.$refs.topicoSalaAula
          this.$nextTick(() => {
            $topicoSalaAulaRef.montarEstruturaSalaAula()
          })

          this.$emit('topicoChange', this.ementaCurso)

          let concluido = 0
          if (!this.isTopicoVideo && !this.isTopicoQuestaoDiscursiva && !this.isTopicoQuestaoObjetiva && !this.isTopicoJaleklinico) {
            concluido = 1
          }

          SalaAulaAPI.atualizarVisualizacaoTopico(data.topico_escolhido.ementa_id, concluido).then(() => {
            loader.hide()
            if (this.autoplay) {
              window.eventBus.$emit('iniciarVideo')
            }
            if (concluido === 1) {
              this.$store.dispatch('ementaIdConcluida', data.topico_escolhido.ementa_id)
            }
          }).catch(() => {
            loader.hide()
          })
        })
    }
  }
}
</script>

<style scoped>

</style>
